export { sanitiseAsciiMath, sanitiseLatexString };

/**
 * Replace latex strings that may be problematic when converted into ascii and parsed by `MathJS`
 *
 * `\times` will be converted to "xx" in ascii math by `MathLive`, so we need to change it
 * @param latex latex string
 * @returns sanitised string
 */
const sanitiseLatexString = (latex: string) =>
  latex.replaceAll("\\times", "\\operatorname{\\footnotesize ✕}");
/**
 * Replace ascii characters that cannot be parsed by `MathJS` into their semantic equivalent
 * @param asciiMath ascii math strings, typically returned by MathLive
 * @returns sanitised string
 */
const sanitiseAsciiMath = (asciiMath: string) =>
  asciiMath
    .replaceAll(":", "/")
    .replaceAll("÷", "/")
    .replaceAll("⋅", "*")
    .replaceAll("✕", "*")
    .replaceAll('"', "")
    .replaceAll("×", "*")
    .replaceAll("∗", "*")
    .replaceAll("−", "-")
    // MathLive converts ' to ^′, which is not parsed by MathJS
    // ' is also reserved for transpose, so we replace it with ` that looks quite similar
    .replaceAll("^′", "`");
